import DOMPurify from "dompurify";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../../../utils/ConfigContext";
import { StyledSubmitButton } from "../../../Report/new/Footer/Footer-styled";
import { StyledOverlay } from "./Message-styled";

const Message = ({
  colors,
  color,
  onSubmit,
  onCancel,
  children,
  title,
  subtitle,
  position,
  bg,
  submitTitle,
  cancelTitle,
  btnDirPosition = "row",
  onAdditionBtnClick,
  additionalBtnTitle = "",
  onClose,
}) => {
  const { t } = useTranslation("common");
  const { config } = useContext(ConfigContext);
  const safeTitle = title ? DOMPurify.sanitize(title) : "";
  const btnHeight = btnDirPosition === "column" ? "34" : undefined;

  return (
    <StyledOverlay position={position} bg={bg}>
      <div
        style={{
          padding: 20,
          background: "#fff",
          borderRadius: 8,
          wordWrap: "break-word",
          boxSizing: "border-box",
          maxHeight: "100%",
          overflow: "auto",
          position: "relative",
        }}
      >
        {onClose && (
          <div
            onClick={onClose}
            style={{
              position: "absolute",
              right: 4,
              top: 4,
              cursor: "pointer",
            }}
          >
            <svg
              stroke="currentColor"
              fill="#525252"
              strokeWidth="0"
              viewBox="0 0 512 512"
              height="20px"
              width="20px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="32"
                d="M368 368 144 144m224 0L144 368"
              ></path>
            </svg>
          </div>
        )}
        {title || subtitle ? (
          <>
            {title && (
              <p
                className="title"
                dangerouslySetInnerHTML={{ __html: safeTitle }}
              />
            )}
            {subtitle && <p className="subtitle">{subtitle}</p>}
          </>
        ) : (
          children
        )}
        {(onSubmit || onCancel) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: btnDirPosition === "row" ? 20 : 0,
              marginTop: 10,
              flexDirection: btnDirPosition,
            }}
          >
            {onSubmit && (
              <StyledSubmitButton
                bg={colors?.submit?.bg ?? color}
                color={colors?.submit?.textColor ?? "#ffffff"}
                onClick={onSubmit}
                height={btnHeight}
              >
                {submitTitle ?? t("screen.widget.common.yes")}
              </StyledSubmitButton>
            )}
            {onCancel && (
              <StyledSubmitButton
                color={colors?.cancel?.textColor ?? color ?? config.opsColor}
                bg={colors?.cancel?.bg ?? "#ffffff"}
                borderWidth={1}
                onClick={onCancel}
                height={btnHeight}
              >
                {cancelTitle ?? t("screen.widget.common.no")}
              </StyledSubmitButton>
            )}
            {additionalBtnTitle && (
              <StyledSubmitButton
                color="var(--fontColor)"
                bg="#ffffff"
                height={btnHeight}
                borderWidth={1}
                onClick={onAdditionBtnClick}
              >
                {additionalBtnTitle}
              </StyledSubmitButton>
            )}
          </div>
        )}
      </div>
    </StyledOverlay>
  );
};

export default Message;
